import { Model as BaseModel } from 'rawmodel';

export default class Model extends BaseModel {

}
